<template>
  <div>
    <form
      autocomplete="off"
      @submit.prevent="createProductoCodigoRastreo"
    >
      <AtomInputPrimary
        v-model="codigoRastreo.nombre"
        :inputError="$v.codigoRastreo.nombre.$error"
        :label="$t('mEditionProductTrackingCodesCreate.inputs.nombre.label')"
        :message="$t('mEditionProductTrackingCodesCreate.inputs.nombre.message')"
        :messageError="messageErrorNombre"
        name="nombre"
        :placeholder="$t('mEditionProductTrackingCodesCreate.inputs.nombre.placeholder')"
        type="text"
        @blur="$v.codigoRastreo.nombre.$touch()"
      />

      <AtomTextAreaPrimary
        v-model="codigoRastreo.codigo_head"
        :inputError="$v.codigoRastreo.codigo_head.$error"
        :label="$t('mEditionProductTrackingCodesCreate.inputs.codigo_head.label')"
        :messageError="messageErrorCodigoHead"
        name="codigo_head"
        rows="8"
        @blur="$v.codigoRastreo.codigo_head.$touch()"
      />

      <AtomTextAreaPrimary
        v-model="codigoRastreo.codigo_body"
        :inputError="$v.codigoRastreo.codigo_body.$error"
        :label="$t('mEditionProductTrackingCodesCreate.inputs.codigo_body.label')"
        :messageError="messageErrorCodigoBody"
        name="codigo_body"
        rows="8"
        @blur="$v.codigoRastreo.codigo_body.$touch()"
      />

      <AtomButtonPrimary :button-primary="buttonPrimary"/>
      <AtomButtonSecondary
        v-if="false"
        :button-secondary="buttonSecondary.reset"
      />
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators'
// import { validateScriptTags } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionProductTrackingCodesCreate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductTrackingCodesCreate.buttonPrimary'),
        class: 'margin-right-medium margin-top-large',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-reset-secondary',
          component: '',
          icon: '',
          method: '',
          text: this.$t('aButtonSecondary.actions.reset'),
          type: 'reset'
        }
      },

      codigoRastreo: {
        codigo_body: '',
        codigo_head: '',
        nombre: ''
      }
    }
  },

  validations: {
    codigoRastreo: {
      codigo_body: {
        required: requiredIf(function () {
          return !this.codigoRastreo.codigo_head.length
        })
        // validScript: validateScriptTags
      },

      codigo_head: {
        required: requiredIf(function () {
          return !this.codigoRastreo.codigo_body.length
        })
        // validScript: validateScriptTags
      },

      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(1),
        required
      }
    }
  },

  computed: {
    messageErrorCodigoBody () {
      return this.$validation.getValidationMessage('mEditionProductTrackingCodesCreate', this.$v.codigoRastreo.codigo_body, 'codigo_body')
    },

    messageErrorCodigoHead () {
      return this.$validation.getValidationMessage('mEditionProductTrackingCodesCreate', this.$v.codigoRastreo.codigo_head, 'codigo_head')
    },

    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionProductTrackingCodesCreate', this.$v.codigoRastreo.nombre, 'nombre')
    }
  },

  methods: {
    createProductoCodigoRastreo () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        // this.codigoRastreo.codigo_body = this.$utils.parseScriptTags(this.codigoRastreo.codigo_body)
        // this.codigoRastreo.codigo_head = this.$utils.parseScriptTags(this.codigoRastreo.codigo_head)
        this.buttonPrimary.sending = true
        this.$services.create('producto', 'createProductoCodigoRastreo', this.codigoRastreo, [this.$route.params.id])
          .then(response => {
            this.$modal.updateData('readElement')
            this.$alerts.pushAlert('mEditionProductTrackingCodesCreate', 'createProductoCodigoRastreo', 'success')
            this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.trackingCodes.subject')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductTrackingCodesCreate', 'createProductoCodigoRastreo', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
